import { ExpandContent } from "@bridgesplit/ui";

import TestTransaction from "./TestTransaction";
import { Page } from "../wrappers";

export default function Testing() {
    return (
        <Page hideAlerts>
            <ExpandContent defaultExpanded textVariant="h1" header="Transaction testing">
                <TestTransaction />
            </ExpandContent>
        </Page>
    );
}
